import { MerchantLogo } from '@mxenabled/mxui'

import { DATE_FORMATS_INTL, formatDate } from '../../../../core/constants'
import type { CategoryTransactionsBlockData } from '../../../../core/types/InsightsInstanceSlotData'
import { fromUnixUTC } from '../../../../core/utils/DateUtil'
import { formatCurrency } from '../../../../core/utils/NumberFormatting'

import TransactionListCard from '../../../components/TransactionListCard'
import type { BlockProps } from '../../types'

const formatTxnDate = (date?: number) => {
  if (typeof date !== 'number' || Number.isNaN(date)) return ''
  const parsed = fromUnixUTC(date)
  if (Number.isNaN(parsed.getTime())) return ''
  return formatDate(parsed, DATE_FORMATS_INTL.FULL_MONTH_DAY)
}

export const CategoryTransactionsBlock = ({
  payload,
}: BlockProps<CategoryTransactionsBlockData>) => {
  const tx = payload.instance_slot_data.primary_transaction
  if (!tx) return null

  return (
    <TransactionListCard
      rows={[
        {
          amount: formatCurrency(tx.amount, '0,0.00'),
          leading: tx.merchant_guid ? (
            <MerchantLogo
              alt={tx.merchant_name || tx.description || ''}
              categoryGuid={tx.category_guid ?? ''}
              merchantGuid={tx.merchant_guid}
              size={32}
            />
          ) : undefined,
          subtitle: formatTxnDate(tx.date),
          title: tx.description ?? '',
        },
      ]}
    />
  )
}
